<template>
  <div>
    <div class="page-head">
      <div>
        <h3>{{ form._id ? 'Edit' : 'Add New'}} Client</h3>
        <p class="page-head-sub">Client details used on invoices and in Tripletex</p>
      </div>
    </div>
    <b-row class="form-card mx-0">
      <b-form @submit="onSubmit" class="w-100 d-flex flex-wrap">
        <b-col sm="6" lg="4" class="pb-3">
          <label for="oNumber">Org. number</label>
          <b-form-input
          id="oNumber"
          v-model="form.oNumber"
          type="text"
          placeholder="org. number"
          :state="oNumValid"
          trim>
          </b-form-input>
        </b-col>

        <b-col sm="6" lg="4" class="pb-3">
          <label for="name">Name</label>
          <b-form-input
          id="name"
          v-model="form.name"
          type="text"
          placeholder="client's name"
          required>
          </b-form-input>
        </b-col>

        <b-col sm="6" lg="4" class="pb-3">
          <label for="email">Email</label>
          <b-form-input
          id="email"
          v-model="form.email"
          type="text"
          placeholder="email"
          required
          trim>
          </b-form-input>
        </b-col>

        <b-col sm="6" lg="4" class="pb-3">
          <label for="phone">Phone</label>
          <b-form-input
          id="phone"
          v-model="form.phone"
          type="text"
          placeholder="phone"
          :state="phoneValid"
          trim>
          </b-form-input>
        </b-col>

        <b-col sm="6" lg="4" class="pb-3">
          <label for="address">Address</label>
          <b-form-input
          id="address"
          v-model="form.address"
          type="text"
          placeholder="address"
          class="mr-3">
          </b-form-input>
        </b-col>

        <b-col sm="6" lg="4" class="pb-3">
          <label for="postCode">Post code</label>
          <b-form-input
          id="postCode"
          v-model="form.postCode"
          type="text"
          placeholder="post code"
          trim>
          </b-form-input>
        </b-col>

        <b-col sm="6" lg="4" class="pb-3">
          <label for="city">City</label>
          <b-form-input
          id="city"
          v-model="form.city"
          type="text"
          placeholder="city"
          class="mr-3">
          </b-form-input>
        </b-col>

        <b-col sm="12" class="text-right pt-2">
          <b-button class="px-5" type="submit" variant="primary">Save client</b-button>
        </b-col>
      </b-form>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios';

import fixed from '../../fixed';

const API_URL = `${fixed.API_URL}/admin`;
export default {
  data: () => ({
    form: {
      oNumber: '',
      name: '',
      email: '',
      phone: '',
      address: '',
      postCode: null,
      city: '',
    },
  }),
  mounted() {
    if (this.$route.query._id) this.form = Object.assign(this.form, this.$route.query); // eslint-disable-line
  },
  computed: {
    oNumValid() {
      return this.form?.oNumber.length ? this.form.oNumber.length === 9 : null;
    },
    phoneValid() {
      return this.form?.phone.length ? this.form.phone.length === 8 : null;
    },
  },
  methods: {
    async onSubmit(e) {
      e.preventDefault();
      try {
        this.form.isPrivate = !this.form.oNumber;
        this.form.ttexId = +this.form.ttexId;
        await axios.post(`${API_URL}/clients`, this.form, { withCredentials: true });
        this.$router.push({ name: 'companies' });
      } catch (err) {
        this.$toast.error(err?.response?.statusText || 'error while saving client');
      }
    },
  },
};
</script>

<style>

</style>
